import moment from 'moment';
import Base from './Base';

export default class ScheduleChangeRequest extends Base {
    constructor(props) {
        super();
        this.import(props);
    }

    import(props) {
        if (!props) {
            props = {};
        }

        if (typeof props === 'number') {
            this.id = props;
            return;
        }

        this.id = this.assign('id', props);
        this.originalScheduleId = this.assign('originalScheduleId', props);
        this.requestedById = this.assign('requestedById', props);
        this.swapWithEmployeeId = this.assign('swapWithEmployeeId', props);
        this.swapWithScheduleId = this.assign('swapWithScheduleId', props);
        this.type = this.assign('type', props) || 'swap';
        this.proposedChanges = this.assign('proposedChanges', props);
        this.reason = this.assign('reason', props);
        this.status = this.assign('status', props) || 'pending_employee';
        this.employeeApproved = this.assign('employeeApproved', props);
        this.employeeApprovedAt = props.employeeApprovedAt ? moment(props.employeeApprovedAt) : null;
        this.adminApproved = this.assign('adminApproved', props);
        this.processedById = this.assign('processedById', props);
        this.processedAt = props.processedAt ? moment(props.processedAt) : null;
        this.adminNotes = this.assign('adminNotes', props);
        
        // Nested objects
        this.originalSchedule = this.assign('originalSchedule', props);
        this.requestedBy = this.assign('requestedBy', props);
        this.swapWithEmployee = this.assign('swapWithEmployee', props);
        this.swapWithSchedule = this.assign('swapWithSchedule', props);
        this.processedBy = this.assign('processedBy', props);
        
        this.createdAt = props.createdAt ? moment(props.createdAt) : null;
        this.updatedAt = props.updatedAt ? moment(props.updatedAt) : null;
    }

    export() {
        return {
            id: this.id,
            originalScheduleId: this.originalScheduleId,
            swapWithScheduleId: this.swapWithScheduleId,
            type: this.type,
            proposedChanges: this.proposedChanges,
            reason: this.reason
        };
    }

    get displayStatus() {
        const statusMap = {
            pending_employee: 'Așteaptă aprobarea colegului',
            pending_admin: 'Așteaptă aprobarea administratorului',
            approved: 'Aprobat',
            rejected: 'Respins',
            cancelled: 'Anulat'
        };
        return statusMap[this.status] || this.status;
    }

    get displayType() {
        const typeMap = {
            swap: 'Schimb',
            modify: 'Modificare',
            cancel: 'Anulare',
            add: 'Adăugare'
        };
        return typeMap[this.type] || this.type;
    }

    get statusColor() {
        const colorMap = {
            pending_employee: 'yellow',
            pending_admin: 'orange',
            approved: 'green',
            rejected: 'red',
            cancelled: 'neutral'
        };
        return colorMap[this.status] || 'neutral';
    }
}
